import styled from "styled-components"

const InnerWrapper = styled.div`
  position: relative;
  min-width: ${(props) => props.size}px;
  min-height: ${(props) => (props.horizontal ? props.height : props.size)}px;
`

export default InnerWrapper
